// src/i18n/es/lockers.js
const lockers = {
    name: 'Taquilla |||| Taquillas',
    title: 'Gestión de Taquillas',
    titles: {
        list: 'Taquillas',
        create: 'Nueva Taquilla',
        edit: 'Editar Taquilla',
        show: 'Detalles de Taquilla',
    },
    fields: {
        id: 'ID',
        displayNumber: 'Nº',
        display_number: 'Nº',
        hardwareId: 'ID',
        hardware_id: 'ID',
        hotel: 'Hotel',
        hotelId: 'Hotel',
        hotel_id: 'Hotel',
        zone: 'Zona',
        zoneId: 'Zona',
        zone_id: 'Zona',
        lockerType: 'Tipo',
        locker_type: 'Tipo de Taquilla',
        lockerTypeId: 'Tipo',
        lockerController: 'Controlador',
        controller: 'Controlador',
        status: 'Estado',
        statusReason: 'Motivo del estado',
        status_reason: 'Razón del Estado',
        assignment: 'Asignación',
        assignmentId: 'Asignación',
        assignment_id: 'ID de Asignación',
        assignedAt: 'Asignada el',
        assigned_at: 'Fecha de Asignación',
        reservedUntil: 'Reservada hasta',
        lastMaintenance: 'Último mantenimiento',
        last_maintenance_at: 'Último Mantenimiento',
        notes: 'Notas',
        blockReason: 'Motivo del bloqueo',
        isActive: 'Activa',
        createdAt: 'Creada',
        updatedAt: 'Actualizada',
    },
    status: {
        available: 'Disponible',
        occupied: 'Ocupada',
        maintenance: 'Mantenimiento',
        outOfService: 'Fuera de servicio',
        out_of_service: 'Fuera de Servicio',
        reserved: 'Reservada',
        blocked: 'Bloqueada',
    },
    filters: {
        title: 'Filtros',
        search: 'Buscar por número o ID...',
        search_placeholder: 'Buscar taquillas...',
        status: 'Estado',
        all_status: 'Todos los estados',
        zone: 'Zona',
        all_zones: 'Todas las zonas',
        type: 'Tipo',
        all_types: 'Todos los tipos',
        hotel: 'Hotel',
        all_hotels: 'Todos los hoteles',
        available_only: 'Solo disponibles',
        occupied_only: 'Solo ocupadas',
        maintenance_only: 'En mantenimiento',
        assignment: 'Asignación',
        with_assignment: 'Con asignación',
        without_assignment: 'Sin asignación',
    },
    actions: {
        create: 'Nueva Taquilla',
        edit: 'Editar',
        delete: 'Eliminar',
        assign: 'Asignar',
        release: 'Liberar',
        maintenance: 'Mantenimiento',
        activate: 'Activar',
        deactivate: 'Desactivar',
        view_details: 'Ver detalles',
        view_history: 'Ver historial',
        bulk_assign: 'Asignar múltiples',
        bulk_release: 'Liberar múltiples',
        export: 'Exportar taquillas',
        import: 'Importar taquillas',
        block: 'Bloquear',
        unblock: 'Desbloquear',
    },
    messages: {
        no_lockers: 'No se encontraron taquillas',
        loading: 'Cargando taquillas...',
        create_success: 'Taquilla creada correctamente',
        update_success: 'Taquilla actualizada correctamente',
        delete_success: 'Taquilla eliminada correctamente',
        delete_confirm: '¿Está seguro de que desea eliminar esta taquilla?',
        assign_success: 'Taquilla asignada correctamente',
        release_success: 'Taquilla liberada correctamente',
        maintenance_success: 'Taquilla puesta en mantenimiento',
        bulk_assign_success: '%{count} taquillas asignadas correctamente',
        bulk_release_success: '%{count} taquillas liberadas correctamente',
        already_occupied: 'Esta taquilla ya está ocupada',
        not_available: 'Esta taquilla no está disponible',
        invalid_hardware_id: 'El ID de hardware no es válido',
        duplicate_number: 'Ya existe una taquilla con este número',
        block_reason_required: 'Debes indicar un motivo para bloquear la taquilla',
        block_success: 'Taquilla %{displayNumber} bloqueada correctamente',
        block_error: 'Error al bloquear la taquilla',
        unblock_success: 'Taquilla %{displayNumber} desbloqueada correctamente',
        unblock_error: 'Error al desbloquear la taquilla',
    },
    placeholders: {
        block_reason: 'Ej: Puerta averiada, necesita mantenimiento'
    },
    validation: {
        display_number_required: 'El número de taquilla es obligatorio',
        hardware_id_required: 'El ID de hardware es obligatorio',
        zone_required: 'La zona es obligatoria',
        invalid_status: 'Estado no válido',
        number_format: 'El número debe tener el formato correcto',
        hardware_id_format: 'El ID de hardware debe tener el formato correcto',
        reason_required: 'El motivo es obligatorio',
        minLength: 'Mínimo {{min}} caracteres',
        maxLength: 'Máximo {{max}} caracteres',
        positive: 'Debe ser un número positivo'
    },
    help: {
        displayNumber: 'Número visible de la taquilla',
        hardwareId: 'Identificador único del hardware',
        notes: 'Observaciones adicionales sobre la taquilla'
    },
    sections: {
        basic_info: 'Información Básica',
        basic_info_subtitle: 'Datos principales de la taquilla',
        info: 'Información adicional',
        create: 'Crear Taquilla',
        create_subtitle: 'Ingrese los datos de la nueva taquilla'
    },
    warnings: {
        occupied_edit: 'Esta taquilla está ocupada. Algunos campos no se pueden modificar mientras esté en uso.'
    },
    errors: {
        update: 'Error al actualizar la taquilla'
    },
    dialogs: {
        delete_title: 'Eliminar Taquilla',
        delete_message: '¿Estás seguro de que deseas eliminar la taquilla?',
        delete_warning: 'Esta acción no se puede deshacer. La taquilla quedará marcada como inactiva.',
        release_title: 'Liberar Taquilla',
        release_message: '¿Está seguro de que desea liberar la taquilla %{number}?',
        maintenance_title: 'Poner en Mantenimiento',
        maintenance_message: '¿Desea poner la taquilla %{number} en mantenimiento?',
        maintenance_reason: 'Motivo del mantenimiento',
        block_title: 'Bloquear taquilla %{displayNumber}',
    },
    tooltips: {
        available: 'Esta taquilla está disponible para asignar',
        occupied: 'Esta taquilla está actualmente asignada',
        maintenance: 'Esta taquilla está en mantenimiento',
        out_of_service: 'Esta taquilla está fuera de servicio',
        view_assignment: 'Ver detalles de la asignación actual',
    },
    bulk: {
        title: 'Operaciones masivas',
        selected: '%{count} taquillas seleccionadas',
        assign_title: 'Asignar taquillas seleccionadas',
        release_title: 'Liberar taquillas seleccionadas',
        maintenance_title: 'Poner en mantenimiento',
        confirm_assign: '¿Asignar %{count} taquillas?',
        confirm_release: '¿Liberar %{count} taquillas?',
        confirm_maintenance: '¿Poner %{count} taquillas en mantenimiento?',
    },
    notifications: {
        updated: 'Taquilla actualizada correctamente'
    },
    helpers: {
        block_reason: 'Especifique el motivo por el cual se está bloqueando esta taquilla'
    }
};

export default lockers;